import { formatLocalClock, type LocalClockOptions } from "@ttc-spectree/toolbox-contract";

/**
 * Local times for run messages (epic PI-SPEC-SW-E290, feature
 * PI-SPEC-SW-1478, UX-PM-07): every time a Project Manager reads is in their
 * own words and time zone ("at 4:12 PM", "yesterday at 4:40 PM", "at about
 * 2:30 PM"), never an ISO timestamp. The ISO time only appears behind "Copy
 * details for the Admin" (`copy-details.ts`).
 *
 * The wording comes from the contract's queue wording sheet, so the desktop
 * app's notifications and these pages say times the same way.
 */
export { formatLocalClock, formatLocalClockParts, type LocalClockOptions, type LocalClockParts } from "@ttc-spectree/toolbox-contract";

/** An estimate, such as when a usage window resets: "at about 2:30 PM". Null for an unreadable time. */
export function formatAboutTime(iso: string, options: Omit<LocalClockOptions, "about"> = {}): string | null {
  return formatLocalClock(iso, { ...options, about: true });
}

/**
 * The local-time phrase for a component: "at 4:12 PM" today, "yesterday at
 * 4:40 PM", "Mon at 9:05 AM", "Oct 28 at 9:05 AM". Null for a missing or
 * unreadable time, so a caller drops its words instead of showing a raw
 * value. React-free.
 */
export function localTimeOf(iso: string | null | undefined, options: LocalClockOptions = {}): string | null {
  if (typeof iso !== "string") return null;
  return formatLocalClock(iso, options);
}
